// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"hi-z"};